import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Col, Form, Row } from "react-bootstrap";

const AgentSelector = ({ user, agents, selectedAgent, onSelectAgent }) => {
    const renderAgentOptions = (agents, parentId = null, level = 1) => {
        return agents
            .filter(agent => agent.parent === parentId && agent.erp_user_id)
            .map(agent => (
                <React.Fragment key={agent.id}>
                    <option value={agent.erp_user_id}>
                        {'-'.repeat(level)} {agent.name}
                    </option>
                    {renderAgentOptions(agents, agent.id, level + 1)}
                </React.Fragment>
            ));
    };

    return (
        <div className="d-flex justify-content-center mb-2">
            <div className="detail-card p-3 border-0 shadow-sm rounded-4 w-100" style={{ maxWidth: '800px' }}>
                <Form.Group as={Row} className="align-items-center g-2 m-0">
                    <Form.Label column md={4} className="text-end fw-bold text-muted small text-uppercase mb-0">
                        Seleccionar Agente:
                    </Form.Label>
                    <Col md={8}>
                        <Form.Select
                            className="form-control rounded-3 border-light shadow-sm bg-light text-primary fw-bold"
                            value={selectedAgent}
                            onChange={(e) => onSelectAgent(e.target.value)}
                        >
                            <option key={-1} value="all">Todos los agentes</option>
                            <option key={0} value={user.erp_user_id}>{user.get_full_name} (Yo)</option>
                            {renderAgentOptions(agents, user.id)}
                        </Form.Select>
                    </Col>
                </Form.Group>
            </div>
        </div>
    );
};

AgentSelector.propTypes = {
    agents: PropTypes.array.isRequired,
    selectedAgent: PropTypes.string.isRequired,
    onSelectAgent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    user: state.Auth.user
});

export default connect(mapStateToProps)(AgentSelector);
